<template>
  <!-- eslint-disable -->
  <mi-expansion-item
    expand-icon-toggle
    expand-separator
    :model-value="expanded"
    expanded-icon="chevron-1-up"
    expand-icon="chevron-1-down"
  >
    <template #header>
      <div class="ambiguous-results-header">
        <!-- Component variant ID&Name or ID2&Name for old validations -->
        <mi-list-item-label
          v-if="validation"
          class="text-weight-bold"
          lines="3"
        >
          <a
            class="validation-explanation-item__link validation-explanation-item__hover text-subtitle2 text-weight-bold"
            role="button"
            tabindex="0"
            @click="redirectToWindchill(item.ambiguous1Id)"
          >
            {{ item.ambiguous1Id2 }} {{ item.ambiguous1Name }}
          </a>
          <span class="name-separator"> - </span>
          <a
            class="validation-explanation-item__link validation-explanation-item__hover text-subtitle2 text-weight-bold"
            role="button"
            tabindex="0"
            @click="redirectToWindchill(item.ambiguous2Id)"
          >
            {{ item.ambiguous2Id2 }} {{ item.ambiguous2Name }}
          </a>
        </mi-list-item-label>
        <mi-list-item-label
          v-else
          class="text-weight-bold"
          lines="3"
        >
          {{ item.ambiguous1Id2 }} {{ item.ambiguous1Name }} -
          {{ item.ambiguous2Id2 }} {{ item.ambiguous2Name }}
        </mi-list-item-label>

        <div class="flex ambiguous-results-header__secondary-header">
          <!-- Planning period -->
          <mi-list-item-label class="planning-period q-mt-lg">
            {{ item.rangeFrom }}
          </mi-list-item-label>
          <!-- Number of scenarios -->
          <mi-list-item-label class="scenarios q-mt-lg">
            {{ item.explanation.length }} scenario(s)
          </mi-list-item-label>
        </div>
      </div>
    </template>
    <!-- Explanation -->
    <div
      v-for="explanation in item.explanation"
      :key="explanation"
      class="explanation-wrapper"
    >
      <div class="explanation-content" v-html="explanation"></div>
    </div>
  </mi-expansion-item>
</template>

<script>
  import { createWindchillLink } from '@/utils/windchill'
  import { BOM_SHOW_AMBIGUOUS_LINK } from '@/constants'
  import { computed, ref, onMounted } from 'vue'
  import { transformExpression } from '@/utils/formatExplanation'
  import MiExpansionItem from '../../../../../packages/@mi-library/MiExpansionItem/MiExpansionItem.vue'

  export default {
    name: 'BomValidationResultsElementsAmbiguous',
    components: { MiExpansionItem },
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    setup(props) {
      const expanded = ref(false)
      const validation = computed(() => props.item.ambiguous1Id)
      const explanation = ref(props.item.explanation)

      const redirectToWindchill = ruleId => {
        const windchillLink = createWindchillLink(BOM_SHOW_AMBIGUOUS_LINK, ruleId)
        if (windchillLink) window.open(windchillLink, '_blank')
      }

      onMounted(() => {
        if (explanation.value) {
          // eslint-disable-next-line security/detect-object-injection
          Object.keys(explanation.value).forEach(key => {
            // eslint-disable-next-line security/detect-object-injection
            if (explanation.value[key]) {
              // eslint-disable-next-line security/detect-object-injection
              explanation.value[key] = transformExpression(explanation.value[key])
            }
          })
        }
      })

      return {
        redirectToWindchill,
        expanded,
        validation,
        explanation
      }
    }
  }
</script>

<style lang="scss" scoped>
  .validation-explanation {
    gap: .5rem;

    &__card {
      border-color: $mi-anthracite-100;
    }

    &__list {
      list-style-type: none;
    }
  }

  .ambiguous-results-header {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;

    &__secondary-header {
      justify-content: space-between;
    }
  }

  ::v-deep(.q-expansion-item__container) {
    border-style: solid;
    border-width: 1px 0;
    border-color: #afafaf;
  }

  ::v-deep(.mi-expansion-item__header) {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px;
  }

  // stylelint-disable declaration-no-important
  ::v-deep(.q-expansion-item__toggle-icon) {
    width: 14px;
    color: $mi-red-500 !important;
  }

  ::v-deep(.q-item__section--side.mi-expansion-item__expand-icon) {
    margin-top: 4px;
    height: fit-content;
  }

  .validation-explanation-item.mi-list-item {
    min-height: auto;
  }

  .validation-explanation-item__title {
    min-width: 100px;
  }

  .validation-explanation-item__link {
    color: $mi-anthracite-800;
    margin-top: 0;
    margin-bottom: 0;
    text-decoration: none;
  }

  .validation-explanation-item__hover {
    &:hover {
      color: $mi-red-500;
      cursor: pointer;
      text-decoration: underline;
    }
  }

  .name-separator {
    color: $mi-red-500;
  }

  .planning-period,
  .scenarios {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 500;
    color: $mi-silver-700;
  }
</style>
